export default __webpack_public_path__ + "static/media/pending.d7102e96.svg";